// src/components/Pages/ForgotPassword.jsx
import React, { useState, useEffect } from 'react';
import './../../style/Vars.css';
import './../../style/ElementsStyle.css';
import './../../style/ContainersStyles.css';
import { isMobile, isTablet } from 'react-device-detect';
import bgLogin from './img/bglogin.png';
import { FaEnvelope, FaUser, FaArrowLeft, FaLightbulb } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

import Header from './Header';
import Footer from './Footer';

export default function ForgotPassword() {
    const navigate = useNavigate();

    const [nombreUsuario, setNombreUsuario] = useState('');
    const [email, setEmail] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');
    const [enviando, setEnviando] = useState(false);

    const containerClass = isMobile || isTablet
        ? 'login-form-container login-form-container-mobile'
        : 'login-form-container';
    const cardClass = isMobile || isTablet
        ? 'login-form-card login-form-card-mobile'
        : 'login-form-card';
    const inputClass = isMobile || isTablet
        ? 'login-form-input login-form-input-mobile'
        : 'login-form-input';
    const buttonClass = isMobile || isTablet
        ? 'login-form-button login-form-button-mobile'
        : 'login-form-button';

    const containerStyle = {
        backgroundImage: `url(${bgLogin})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    };


    const handleSubmit = async () => {
        setError('');
        setMensaje('');

        if (!nombreUsuario.trim() || !email.trim()) {
            setError('Por favor completa todos los campos');
            return;
        }

        // Validación básica de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Por favor ingresa un correo electrónico válido');
            return;
        }

        setEnviando(true);

        try {
            const response = await api.post(`/RecuperacionContrasena/solicitar`, {
                nombreUsuario: nombreUsuario.trim(),
                email: email.trim()
            });

            if (response.data.exito) {
                // Navegar a la pantalla de ResetPassword para ingresar el token
                // Pasamos el nombre de usuario para facilitarle la vida al usuario
                navigate('/reset-password', {
                    state: {
                        nombreUsuario: nombreUsuario.trim(),
                        mensajeInicial: 'Correo enviado. Por favor revisa tu bandeja y copia el código de recuperación.'
                    }
                });
            } else {
                setError(response.data.mensaje || 'Usuario o correo no encontrado');
            }
        } catch (err) {
            console.error(err);
            if (err.response?.data?.mensaje) {
                setError(err.response.data.mensaje);
            } else {
                setError('Error al procesar la solicitud. Por favor intenta de nuevo.');
            }
        } finally {
            setEnviando(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !enviando) {
            handleSubmit();
        }
    };


    return (
        <div className="page-container">
            <Header />

            <main className="page-main">
                <div className={containerClass} style={containerStyle}>
                    <div className={cardClass} role="form" aria-label="Formulario de recuperación de contraseña">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                            <button
                                onClick={() => navigate('/login')}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    fontSize: '20px',
                                    padding: '5px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                                title="Volver al login"
                            >
                                <FaArrowLeft />
                            </button>
                            <h2 className="login-form-title" style={{ margin: 0 }}>Recuperar Contraseña</h2>
                        </div>

                        <p style={{ color: '#fff', marginBottom: '20px', textAlign: 'center', fontSize: '14px' }}>
                            Ingresa tu nombre de usuario y correo electrónico. Te enviaremos un código para restablecer tu contraseña.
                        </p>

                        <div style={{ position: 'relative', width: '100%', marginBottom: '15px' }}>
                            <FaUser style={{
                                position: 'absolute',
                                left: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#666',
                                fontSize: '16px',
                                zIndex: 1
                            }} />
                            <input
                                type="text"
                                placeholder="Nombre de Usuario"
                                className={inputClass}
                                value={nombreUsuario}
                                onChange={(e) => setNombreUsuario(e.target.value)}
                                onKeyDown={handleKeyDown}
                                aria-label="Nombre de Usuario"
                                style={{ paddingLeft: '40px' }}
                                disabled={enviando}
                            />
                        </div>

                        <div style={{ position: 'relative', width: '100%', marginBottom: '20px' }}>
                            <FaEnvelope style={{
                                position: 'absolute',
                                left: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#666',
                                fontSize: '16px'
                            }} />
                            <input
                                type="email"
                                placeholder="Correo Electrónico"
                                className={inputClass}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                onKeyDown={handleKeyDown}
                                aria-label="Correo Electrónico"
                                style={{ paddingLeft: '40px' }}
                                disabled={enviando}
                            />
                        </div>

                        <button
                            className={buttonClass}
                            onClick={handleSubmit}
                            disabled={enviando}
                            style={{ opacity: enviando ? 0.7 : 1 }}
                        >
                            <FaEnvelope />
                            <span>{enviando ? 'Enviando...' : 'Enviar Instrucciones'}</span>
                        </button>

                        {mensaje && (
                            <div style={{
                                marginTop: '15px',
                                padding: '12px',
                                backgroundColor: 'rgba(76, 175, 80, 0.2)',
                                border: '1px solid rgba(76, 175, 80, 0.5)',
                                borderRadius: '8px',
                                color: '#4CAF50',
                                fontSize: '14px',
                                textAlign: 'center'
                            }}>
                                {mensaje}
                            </div>
                        )}

                        {error && (
                            <div style={{
                                marginTop: '15px',
                                padding: '12px',
                                backgroundColor: 'rgba(244, 67, 54, 0.2)',
                                border: '1px solid rgba(244, 67, 54, 0.5)',
                                borderRadius: '8px',
                                color: '#F44336',
                                fontSize: '14px',
                                textAlign: 'center'
                            }}>
                                {error}
                            </div>
                        )}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
